import z from "zod";
import { PaginationResponseSchema, PaginationSchema } from "../common";

export const LogActionValues = ["create", "update", "delete"] as const;
export const LogEntityTypeValues = [
  "project",
  "district",
  "blog",
  "city",
  "feature",
  "distance",
  "plan",
  "staff",
] as const;

export const LogActionEnum = z.enum(LogActionValues);
export const LogEntityTypeEnum = z.enum(LogEntityTypeValues);

export const ActionLogSchema = z.object({
  id: z.uuidv7(),
  createdAt: z.date(),
  actorId: z.string(),
  actorName: z.string(),
  actorEmail: z.email(),
  action: LogActionEnum,
  entityType: LogEntityTypeEnum,
  entityId: z.string(),
  entityName: z.string(),
  metadata: z.record(z.string(), z.unknown()),
});

export const ActionLogSchemas = {
  list: {
    request: PaginationSchema,
    response: PaginationResponseSchema(ActionLogSchema),
  },
};

export type LogAction = z.infer<typeof LogActionEnum>;
export type LogEntityType = z.infer<typeof LogEntityTypeEnum>;
export type ActionLog = z.infer<typeof ActionLogSchema>;
